import React, { useState, useEffect } from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import ServicesSection from "./ServicesSection";
import ContactSection from "./ContactSection";
import { useSquarespaceContent } from "../hooks/useSquarespaceContent";

const HomePage = () => {
  const [activeSection, setActiveSection] = useState("hero");
  const { content, loading, error } = useSquarespaceContent();

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "-50% 0px -50% 0px",
      threshold: 0
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    const sections = document.querySelectorAll("section[id]");
    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  if (loading) {
    return (
      <div className="homepage">
        <Header activeSection={activeSection} />
        <main>
          <div className="loading-container">
            <div className="loading-spinner">Loading ATSOMNIUM...</div>
          </div>
        </main>
      </div>
    );
  }

  if (error) {
    console.warn('Using fallback data due to error:', error);
  }

  return (
    <div className="homepage">
      <Header activeSection={activeSection} />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ContactSection />
      </main>
    </div>
  );
};

export default HomePage;